module.exports = __webpack_public_path__ + "static/media/fist-raised.0df7833c.svg";